function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { IconButton, Tooltip } from 'seagull';
import { AnchorIcon, AnchorIconGrayscale } from 'seagull/icons';
import { Intent } from "../../infra/access-control";
import { jsx as _jsx } from "react/jsx-runtime";
export default function EnterAccountantAccessButton(props) {
  const {
    variant = 'default',
    testid,
    onClick
  } = props;
  const buttonProps = {
    noPadding: true,
    size: 'small',
    skin: 'transparent',
    'data-testid': testid,
    onClick
  };
  return variant === 'default' ? /*#__PURE__*/_jsx(Tooltip, {
    placement: "top",
    title: "Go to client portal",
    children: /*#__PURE__*/_jsx(IconButton, _objectSpread(_objectSpread({}, buttonProps), {}, {
      intent: Intent.EnterAccountantAccess,
      children: /*#__PURE__*/_jsx(AnchorIcon, {
        width: 24
      })
    }))
  }) : /*#__PURE__*/_jsx(Tooltip, {
    placement: "top",
    title: "Pending Accountant Access approval",
    children: /*#__PURE__*/_jsx(IconButton, _objectSpread(_objectSpread({}, buttonProps), {}, {
      cursorDefault: true,
      children: /*#__PURE__*/_jsx(AnchorIconGrayscale, {})
    }))
  });
}